import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { getElementType, getUnhandledProps } from '../../lib';
import TextArea from '../../addons/TextArea';
import FormField from './FormField';
/**
 * Sugar for <Form.Field control={TextArea} />.
 * @see Form
 * @see TextArea
 */

function FormTextArea(props) {
  var control = props.control;
  var rest = getUnhandledProps(FormTextArea, props);
  var ElementType = getElementType(FormTextArea, props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    control: control
  }));
}
FormTextArea.handledProps = ["as", "control"];
FormTextArea.defaultProps = {
  as: FormField,
  control: TextArea
};
export default FormTextArea;